// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';

// Компоненты
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import FeaturesPage from './components/FeaturesPage';
import AuthPage from './components/AuthPage';
import Dashboard from './components/Dashboard';
import ProfileTab from './components/ProfileTab';
import UsersTab from './components/UsersTab';
import NotificationsTab from './components/NotificationsTab';
import SettingsTab from './components/SettingsTab';
import NotificationToasts from './components/NotificationToasts';
import OrganizationsTab from './components/OrganizationsTab';
import SurveysTab from './components/SurveysTab';
import SurveyPublicPage from './components/SurveyPublicPage';

// Компоненты маршрутов
import ProtectedRoute from './components/routes/ProtectedRoute';
import PublicRoute from './components/routes/PublicRoute';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <Routes>
            {/* ========== ПУБЛИЧНЫЕ МАРШРУТЫ ========== */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/contact" element={<div>Contact Page</div>} />
            <Route path="/pricing" element={<div>Pricing Page</div>} />
            
            {/* Публичная страница анкеты - ОБЯЗАТЕЛЬНО ПОСЛЕ /dashboard/surveys */}
            <Route path="/survey/:public_id" element={<SurveyPublicPage />} />
            
            {/* Страница авторизации */}
            <Route path="/login" element={
              <PublicRoute>
                <AuthPage />
              </PublicRoute>
            } />
            
            {/* ========== ЗАЩИЩЕННЫЕ МАРШРУТЫ ========== */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<ProfileTab />} />
              <Route path="users" element={<UsersTab />} />
              <Route path="organizations" element={<OrganizationsTab />} />
              <Route path="surveys" element={<SurveysTab />} />
              <Route path="notifications" element={<NotificationsTab />} />
              <Route path="settings" element={<SettingsTab />} />
            </Route>
            
            {/* ========== РЕДИРЕКТЫ ========== */}
            <Route path="/profile" element={<Navigate to="/dashboard/profile" replace />} />
            <Route path="/admin" element={<Navigate to="/dashboard" replace />} />
            <Route path="/signin" element={<Navigate to="/login" replace />} />
            <Route path="/signup" element={<Navigate to="/login" replace />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            
            {/* ========== 404 PAGE ========== */}
            <Route path="/404" element={
              <div className="min-vh-100 d-flex align-items-center justify-content-center">
                <div className="text-center">
                  <h1 className="display-1">404</h1>
                  <p className="lead">Страница не найдена</p>
                  <a href="/" className="btn btn-primary">На главную</a>
                </div>
              </div>
            } />
            
            {/* Catch-all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        <NotificationToasts />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;